import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useApiClient } from "../../../apiClient";
import { CoachDto } from "../../../models/coach/dto/coach.dto";
import { CreateCoachInputDto } from "../../../models/coach/dto/create-coatch.dto";
import { GET_COACH_QUERY_KEY } from "./useGetCoach";
import { GET_COACHS_QUERY_KEY } from "./useListCoachs";

export const useCreateCoach = () => {
    const client = useApiClient();
    const queryClient = useQueryClient();
    return useMutation({
        mutationKey: ['createCoach'],
        mutationFn: (dto: CreateCoachInputDto) => client.fetchApi<CoachDto, CreateCoachInputDto>({ endpoint: 'coachs', method: 'POST', body: dto }),
        onSuccess: (data, variables) => {
            queryClient.setQueryData(GET_COACH_QUERY_KEY(data.id), () => data);
            queryClient.setQueryData(GET_COACHS_QUERY_KEY(variables.organizationId), (prevList: CoachDto[]) => {
                return [...prevList, data].sort((a, b) => {
                    return a.firstName.localeCompare(b.firstName);
                });
            });
        }
    });
};